import React, {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {selNotiDrawerOpen, selNotiItems} from 'module/Noti/selector/NotiSelector';
import {NotiListItem} from 'module/Noti/component/NotiListItem';
import {notiDrawerOpenAction} from 'module/Noti/action/NotiDrawerAction';
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import {List, SwipeableDrawer, useTheme} from '@mui/material';
import {useHorizontalResize} from 'hook/useHorizontalResize';
import {ModalKey} from 'module/Modal/type/ModalKey';
import {css} from '@emotion/react'


export const NotiDrawer = React.memo(() => {
	const theme = useTheme()

	const cssHeaderButton = css`
		width: 100%;
		text-transform: none;
		border-bottom-width: 1px;
		border-bottom-style: solid;
		border-bottom-color: ${theme.palette.action.disabledBackground};
		border-radius: 0;
	`
	const cssHeader = css`
		width: 100%;
		display: flex;
		align-items: center;
		padding: ${theme.spacing(1, 3, 1, 1)};
		justify-content: space-between;
		align-content: space-between;
	`
	const cssDrawerContent = css`
		height: 100%;
	`
	const cssResizeHandle = css`
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 2px;
	`
	const cssNoMessages = css`
		display: flex;
		align-items: center;
		justify-content: space-around;
		color: #6c6c6c;
		margin: ${theme.spacing(2)};
	`

	const open = useSelector(selNotiDrawerOpen);
	const items = useSelector(selNotiItems);
	const {ResizeHandle, width} = useHorizontalResize({modalKey: ModalKey.NotiDrawer, resizeLeft: true, minWidth: 100, defaultWidth: 540})

	const dispatch = useDispatch();
	const onOpen = useCallback(() => dispatch(notiDrawerOpenAction(true)), [dispatch]);
	const onClose = useCallback(() => dispatch(notiDrawerOpenAction(false)), [dispatch]);
	return (
		<SwipeableDrawer
			anchor={'right'}
			open={open}
			onOpen={onOpen}
			onClose={onClose}
			swipeAreaWidth={8}
		>
			<div
				css={cssDrawerContent}
				style={{minWidth: width, maxWidth: width}}
			>
				<Button css={cssHeaderButton} onClick={onClose}>
					<div css={cssHeader}>
						<ChevronRightIcon/>
						<Typography component={'h3'}>Benachrichtigungen</Typography>
					</div>
				</Button>
				<List>
					{items.map(item => <NotiListItem key={item.id} item={item}/>)}
					{!items.length && <div css={cssNoMessages}>Keine Nachrichten vorhanden</div>}
				</List>
				<ResizeHandle css={cssResizeHandle}/>
			</div>
		</SwipeableDrawer>
	)
})